import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IPlan {
  addons: string[];
  downloadRemaining: {
    analysis_report: number | null;
    api: number | null;
    article: number | null;
    data_set: number | null;
    excel: number | null;
    image_pdf: number | null;
    mutible_login: number | null;
    pdf_svg: number | null;
  };
}

interface IUser {
  full_name: string;
  id: string;
  plan: IPlan;
  permission?: {
    isViewMoreRangeData: boolean; //view_unlimited_data
    isViewOptionChart: boolean;
    isViewDetails: boolean;
    isDownloadExcel: boolean;
    isDownloadPdf: boolean;
    isDownloadPng: boolean;
    isGetNoti: boolean;
    isRegisterAPI: boolean;
    isHaveAI: boolean;
  };
  is_frist_login: boolean;
  isShowUpdateInfo: boolean;
  isShowTour: boolean;
}

interface IState {
  access_token: string;
  refresh_token: string;
  user: IUser | null;
}

const initialState: IState = {
  access_token: '',
  refresh_token: '',
  user: null,
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<Partial<IState>>) => {
      const user = action.payload.user;
      if (user) {
        const addons = user.plan.addons;
        const downloadRemaining = user.plan.downloadRemaining;

        const updatedUser = {
          ...user,
          permission: {
            isRegisterAPI:
              addons.includes('rest_api_indices') ||
              downloadRemaining.api === null ||
              Number(downloadRemaining.api) > 0,
            isHaveAI: addons.includes('ai_data_analysis'),
            isViewMoreRangeData: addons.includes('view_unlimited_data'),
            isViewOptionChart: addons.includes('view_optional_chart'),
            isViewDetails: addons.includes('view_data_details'),
            isGetNoti: addons.includes(
              'receive_notification_and_reminder_updated_data',
            ),
            isDownloadExcel:
              addons.includes('trend_forecast_unlimit_slot') ||
              downloadRemaining.excel === null ||
              Number(downloadRemaining.excel) > 0,
            isDownloadPdf:
              addons.includes('trend_pdf_svg_unlimit_slot') ||
              downloadRemaining.image_pdf === null ||
              Number(downloadRemaining.pdf_svg) > 0,
            isDownloadPng:
              addons.includes('trend_image_pdf_unlimit_slot') ||
              downloadRemaining.image_pdf === null ||
              Number(downloadRemaining.image_pdf) > 0,
          },
          isShowUpdateInfo: user.is_frist_login,
          isShowTour: user.is_frist_login,
        };

        return { ...state, ...action.payload, user: updatedUser };
      }

      return { ...state, ...action.payload };
    },
  },
});

export const { setUserData } = userDataSlice.actions;
export default userDataSlice.reducer;
